import { type TableV2HostDependencies } from '@databases/frontend/table-v2-host';
import React from 'react';

import App from './app.tsx';

function extractAdditionalContextFromQueryParams(
  parentQueryParamsString: string,
  selfQueryParamsString: string,
) {
  const queryParams = new URLSearchParams(parentQueryParamsString);
  const selfQueryParams = new URLSearchParams(selfQueryParamsString);

  return {
    // Legacy editor database value embeds are setting the entryId and fieldId
    // in the iframe query params. Standard embeds are setting it in the
    // parent frame query params.
    entryId: selfQueryParams.get('entryId') ?? queryParams.get('entryId'),
    fieldId: selfQueryParams.get('fieldId') ?? queryParams.get('fieldId'),
    referencing: selfQueryParams.get('referencing') === 'true',
    savedViewId: selfQueryParams.get('savedViewId') ?? queryParams.get('savedViewId'),
    unsavedViewId: selfQueryParams.get('unsavedView') ?? queryParams.get('unsavedView'),
  };
}

const AppWithQueryParamContext = ({
  tableV2Host,
}: {
  tableV2Host?: TableV2HostDependencies;
}) => {
  const { entryId, fieldId, referencing, savedViewId, unsavedViewId } =
    extractAdditionalContextFromQueryParams(
      /* oxlint-disable-next-line core/no-restricted-syntax */ // eslint-disable-next-line no-restricted-syntax
      window.parent.location.search,
      /* oxlint-disable-next-line core/no-restricted-syntax */ // eslint-disable-next-line no-restricted-syntax
      window.location.search,
    );

  return (
    <App
      tableV2Host={tableV2Host}
      entryId={entryId}
      fieldId={fieldId}
      referencing={referencing}
      savedViewId={savedViewId}
      unsavedViewId={unsavedViewId}
    />
  );
};

export default React.memo(AppWithQueryParamContext);
